import React from "react";
import { cn } from "../../../common/u1/cn";
import { ClockIcon, CheckCircleIcon } from "../../../../assets/ui/icons";

/* A tinted callout: a mark, a headline, and a line explaining it.
 *
 * Two tones, each with its own mark, because the tone is the message —
 * "pending" and "done" must not be distinguishable by colour alone.
 */
const TONES = {
  pending: {
    box: "bg-[var(--orange-soft)] border-[var(--orange-border)]",
    title: "text-[var(--coral-deep)]",
    body: "text-[var(--ink-2)]",
    mark: <ClockIcon size={22} className="text-[var(--coral)]" />,
  },
  done: {
    box: "bg-[var(--success-soft)] border-[var(--verified-border)]",
    title: "text-[var(--success)]",
    body: "text-[var(--ink-2)]",
    mark: (
      <CheckCircleIcon size={22} fill="transparent" stroke="var(--success)" className="" />
    ),
  },
};

export const NoticeBox = ({ tone = "pending", title, children, className = "" }) => {
  const t = TONES[tone] || TONES.pending;

  return (
    <div className={cn("flex items-start gap-3 rounded-[11px] border p-4", t.box, className)}>
      <span className="mt-px shrink-0 flex">{t.mark}</span>
      <div className="min-w-0">
        {title && (
          <div className={cn("mb-0.5 text-[14.5px] font-bold font-sans", t.title)}>{title}</div>
        )}
        <div className={cn("text-[13px] leading-[1.5] font-sans", t.body)}>{children}</div>
      </div>
    </div>
  );
};

export default NoticeBox;
